<modal-layout>
    <!-- content -->
    <div modalBody>
        <p class="h4 m-t-8">{{ product.name }}</p>

        <product-tier-price [product]="product"
                            (qtyChange)="handleQtyChange($event)"
                            class="block m-t-8"></product-tier-price>
    </div>
</modal-layout>